import * as React from "react";
import { Header, Segment, Divider, Menu, Label } from "semantic-ui-react";
import Update from "../api/models/Update";
import { failOnNotOk, responseAsJson } from "../utils/fetch-helper";
import * as moment from "moment";

interface IOwnState {
	Current: Update
}

type StatusInfo = { 
	id: number;
	message: string;
	color: string;
}

export default class MainPage extends React.Component<null, IOwnState> {
	statuses = [
		{ id: 1, message: "Definitely NO", color: "red" } as StatusInfo,
		{ id: 2, message: "Technically NO, but...", color: "teal" } as StatusInfo,
		{ id: 3, message: "Definitely YES", color: "green" } as StatusInfo,
		{ id: 4, message: "Technically YES, but...", color: "green" } as StatusInfo
	]

	componentDidMount() {
		fetch("/api/current")
			.then(r => failOnNotOk(r, null))
			.then(r => responseAsJson<Update>(r))
			.then(r => this.setState({ Current: r }));
	}

	render() {
		return (
			<div style={{ paddingTop: "1em" }}>
				<Header as="h4" textAlign="center" style={{ color: "white" }}>
					I'm parked in Boston<br />CAN I SAVE MY SPACE?
				</Header>

				{this.state && this.state.Current &&
					<div style={{paddingBottom: "100px"}}>
						<Segment raised size="massive" inverted color={this.statuses.find(s=>s.id==this.state.Current.Status).color as any}>
							<Header as="h1" textAlign="center">{this.statuses.find(s => s.id == this.state.Current.Status).message}</Header>
						</Segment>

						<Segment.Group stacked>
							<Segment secondary><b>Because...</b></Segment>
							{this.state.Current.Rules.sort((a, b) => a.Rule.IsOfficial ? -1:1).map(r => 
								<Segment key={r.RecordID}>
									{r.Rule.IsOfficial &&
										<Label color="green" horizontal style={{ float: "right" }}>Official</Label>
									}
									
									<a target="_blank" href={r.Rule.Link} dangerouslySetInnerHTML={{__html: r.Rule.Description}}></a>
								</Segment>
							)}
							{this.state.Current.Note && 
								<Segment>
									{this.state.Current.Note}
									<Label color="yellow" horizontal style={{ float: "right" }}>Note</Label>
								</Segment>
							}
						</Segment.Group>

						<a className="weatherwidget-io" href="https://forecast7.com/en/42d36n71d06/boston/?unit=us" data-label_1="BOSTON" data-days="3" data-theme="sky" >BOSTON</a>
						{
							!function(d,s,id) {
								var js:any,fjs=d.getElementsByTagName(s)[0];
								if(!d.getElementById(id)) {
									js = d.createElement(s); 
									js.id=id;js.src="https://weatherwidget.io/js/widget.min.js";
									fjs.parentNode.insertBefore(js,fjs);
								}
							}(document,"script","weatherwidget-io-js")
						}

						<Segment tertiary>
							My name is Igor and I live in Southie and for years wasn't sure if and when to put out a space saver.
							Between <a target="_blank" href="https://twitter.com/cityofboston">tweets</a> and <a target="_blank" href="https://www.boston.gov/">web sites</a>,
							there was no one place that could tell me for sure. Now there is. I hope this simple page helps.

							<Divider />

							<h5>In the news...</h5>
							<a href="http://boston.cbslocal.com/2017/01/18/south-boston-space-saver-website-can-i-save-my-space-igor-belagorudsky/" target="_blank">WBZ</a>,&nbsp;
							<a href="http://www.metro.us/boston/southie-resident-s-website-takes-guesswork-out-of-space-savers/zsJqar---QclfyqWur8RJk/" target="_blank">METRO</a>,&nbsp;
							<a href="https://www.youtube.com/watch?v=DNa16hx1Iug&feature=youtu.be" target="_blank">WMCT-TV</a>
						</Segment>

						<Menu borderless fixed="bottom">
							<Menu.Item>No updates needed since {moment(this.state.Current.Date).fromNow()}.</Menu.Item>
						</Menu>
					</div>
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Main/MainPage.tsx